import React from 'react';
import { Upload, RefreshCw, XCircle } from 'lucide-react';

interface ScannerUploadViewProps {
  isScanning: boolean;
  onFileUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onCancelScan?: () => void;
}

export const ScannerUploadView: React.FC<ScannerUploadViewProps> = ({
  isScanning,
  onFileUpload,
  onCancelScan,
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-4 sm:py-6">
      <label
        htmlFor="file-upload"
        className={`w-full max-w-sm aspect-4/3 border-2 border-dashed rounded-2xl flex flex-col items-center justify-center p-6 transition text-center ${
          isScanning
            ? 'opacity-60 pointer-events-none border-slate-300 bg-slate-50'
            : 'border-slate-300 hover:border-indigo-500 bg-slate-50/50 hover:bg-indigo-50/30 cursor-pointer'
        }`}
      >
        <Upload className="w-10 h-10 text-indigo-600 mb-3" />
        <span className="text-sm font-semibold text-slate-800 mb-1">
          Pilih atau Tarik Foto Barcode/QR
        </span>
        <span className="text-xs text-slate-500">Mendukung format JPG, PNG, atau HEIC/WEBP</span>
        <input
          id="file-upload"
          type="file"
          accept="image/*"
          disabled={isScanning}
          onChange={onFileUpload}
          className="hidden"
        />
      </label>
      {isScanning && (
        <div className="mt-4 flex items-center gap-2">
          <div className="px-3 py-1.5 bg-indigo-50 border border-indigo-200 text-indigo-700 rounded-xl text-xs font-medium flex items-center gap-2">
            <RefreshCw className="w-3.5 h-3.5 animate-spin text-indigo-600" />
            <span>Menganalisis citra barcode (maks. 3.5 dtk)...</span>
          </div>
          {onCancelScan && (
            <button
              type="button"
              onClick={onCancelScan}
              className="px-3 py-1.5 bg-rose-50 hover:bg-rose-100 text-rose-700 border border-rose-200 rounded-xl text-xs font-bold flex items-center gap-1.5 transition cursor-pointer"
            >
              <XCircle className="w-3.5 h-3.5 text-rose-600" />
              <span>Batalkan</span>
            </button>
          )}
        </div>
      )}
    </div>
  );
};
